module.exports = __webpack_public_path__ + "static/media/CV_HELLO.f056ae81.mp4";